import { Toast } from '@hubii/ds-hubii'
import { ToastProps } from '@hubii/ds-hubii/lib/components/Toast'
import {
  createContext,
  FunctionComponent,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

interface IToastContext {
  setToast: (
    status?: ToastProps['status'],
    message?: ToastProps['message'],
    icon?: ToastProps['icon'],
    actions?: ToastProps['actions'],
  ) => void
}

const ToastContext = createContext<IToastContext>({
  setToast: () => {},
})

export const useToast = () => useContext(ToastContext)

interface ToastProviderProps {
  children: ReactNode
}

const ToastProvider: FunctionComponent<ToastProviderProps> = ({ children }) => {
  const [toast, _setToast] = useState<ToastProps | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  const setToast = useCallback(
    (
      status: ToastProps['status'],
      message: ToastProps['message'],
      icon?: ToastProps['icon'],
      actions?: ToastProps['actions'],
    ) => {
      setIsVisible(false)
      setTimeout(() => {
        _setToast({ message, status, icon, actions })
        setIsVisible(true)
      }, 50)
    },
    [],
  )

  const value = useMemo(() => {
    return { setToast }
  }, [setToast])

  return (
    <ToastContext.Provider value={value}>
      {children}
      {isVisible && toast && (
        <Toast
          status={toast.status}
          message={toast.message}
          icon={toast.icon}
          actions={toast.actions}
        />
      )}
    </ToastContext.Provider>
  )
}

export default ToastProvider
